import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet"; // React Helmet import
import { useState } from "react";
//Icons
import { FaCheck } from "react-icons/fa6";
import { BsCurrencyDollar } from "react-icons/bs";
import { TbArrowBearLeft2, TbWorldWww } from "react-icons/tb";
import { MdOutlineSupportAgent, MdWeb } from "react-icons/md";
import { GrHost } from "react-icons/gr";
import { FaStar, FaFacebook } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";

//Styles
import "../styles/views/home.css";

//Components
import Footer from "../components/misc/footer";
import Navbar from "../components/misc/navbar";

const externalLinks = require("../data/externalLinks.json");

function Home({ isMexico }) {
  const navigate = useNavigate();
  const IFW = ["2807211", "7922055", "7913078"];
  const img = IFW[Math.floor(Math.random() * IFW.length)] || "2807211";
  const [cText, setCText] = useState(0);

  function handleSendWaM(e) {
    const messages = [
      "Hola me interesa desarrollar una Landing Page",
      "Hola me interesa desarrollar un Sitio Web",
      "Hola me interesa desarrollar una Tienda en Línea",
    ];
    let waLink = `${externalLinks.whatsapp}?text=${messages[e] || messages[0]}`;
    window.open(waLink);
  }

  // Definición de los planes con precio en MXN
  const plans = [
    {
      title: "Landing Page",
      priceMXN: 1499,
      priceGlobal: 79,
      time: 0.2,
      features: [
        "Diseño para Celular, Tablets y Escritorio",
        "Hasta 3 secciones de navegación",
        "Integración con redes sociales",
        "Optimización básica para buscadores (SEO)",
        "Tiempo de entrega rápido",
      ],
    },
    {
      title: "Sitio Web",
      priceMXN: 2499,
      priceGlobal: 129,
      time: 0.6,
      features: [
        "Diseño para Celular, Tablets y Escritorio",
        "Hasta 5 páginas de navegación",
        "Integración con redes sociales",
        "Formulario de contacto funcional",
        "Hosting gratuito por 3 meses",
      ],
    },
    {
      title: "Tienda en Línea",
      priceMXN: 4499,
      priceGlobal: 249,
      time: 1,
      features: [
        "Diseño para Celular, Tablets y Escritorio",
        "Sistema de productos y carrito de compras",
        "Integración con Google Analytics",
        "Mensajería automática a WhatsApp para pedidos",
        "Hosting gratuito por 3 meses",
      ],
    },
  ];

  return (
    <>
      {/* Helmet for SEO tags */}
      <Helmet>
        <title>
          Desarrollo Web en Guadalajara | Diseño y Creación de Páginas Web |
          B-Sites
        </title>

        <meta
          name="description"
          content="Desarrollador web freelance en Guadalajara especializado en desarrollo web, diseño de páginas web, aplicaciones web y diseño UX UI. Cotiza tu página web hoy."
        />

        <meta
          name="keywords"
          content="
    desarrollo web,
    desarrollador web,
    diseño web,
    diseño de paginas web,
    diseño de páginas web,
    disenos web,
    diseños web,
    web desarrollo,
    desarrolla web,
    aplicaciones web,
    páginas web guadalajara,
    desarrolladores web,
    diseño ux ui,
    creacion de paginas web,
    empresas de desarrollo web,
    hacer pagina web precio,
    cotizar pagina web,
    desarrollador web freelance
    "
        />

        <link rel="canonical" href={externalLinks.webPage} />
      </Helmet>

      <Navbar />

      <section id="hero" className="hero">
        <div className="hero-text">
          <h1>
            <strong>B-</strong>Sites
          </h1>
          <h1 className="hero-text-desk" style={{ fontSize: "1.2rem" }}>
            Desarrollo Web y Diseño de Páginas Web en Guadalajara
          </h1>
          <p>
            ¡Estamos listos para transformar tu idea en una solución web de
            calidad!
          </p>
          <a href="#about">
            <motion.button whileHover={{ scale: 1.1 }} className="btn-hero">
              Conoce más
            </motion.button>
          </a>
        </div>
        <div className="hero-image">
          <img
            src={`/images/resource/${img}.webp`}
            alt="Hero"
            draggable={false}
            fetchPriority="high"
          />
        </div>
      </section>

      <motion.section
        id="about"
        className="about container"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <div className="about-content">
          <img
            src="/images/resource/6463428.webp"
            alt="Nuestro Equipo"
            draggable={false}
            loading="lazy"
          />
          <div className="about-text">
            <motion.div
              hidden={cText === 0 ? false : true}
              className="text-container"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >
              <h2 className="section-title">¿Quiénes somos?</h2>
              <motion.h3>
                Tu socio tecnológico para impulsar tu crecimiento digital
              </motion.h3>
              <p>
                Somos una empresa de desarrollo web y diseño web en Guadalajara.
                Creamos páginas web profesionales, aplicaciones web y soluciones
                digitales a medida.
              </p>

              <p>
                Nuestro equipo de desarrolladores web combina diseño UX UI,
                estrategia digital y tecnología moderna para ayudarte a crecer
                online.
              </p>
            </motion.div>

            <motion.div
              hidden={cText === 1 ? false : true}
              className="text-container"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >
              <h2 className="section-title">Costos accesibles</h2>
              <motion.h3>
                Inversión optimizada, resultados excepcionales
              </motion.h3>
              <p>
                En B‑Sites creemos que la innovación digital no debe ser un
                lujo, por eso diseñamos planes flexibles y escalables que se
                adaptan a tu presupuesto.
              </p>
              <p>
                Sin sacrificar la robustez, seguridad ni el soporte continuo.
                Con nosotros, obtienes una solución a medida que maximiza tu
                retorno de inversión desde el día uno.
              </p>
            </motion.div>

            <motion.div
              hidden={cText === 2 ? false : true}
              className="text-container"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >
              <h2 className="section-title">Flexibilidad</h2>
              <motion.h3>
                Tu proyecto, tus reglas un desarrollo que evoluciona contigo
              </motion.h3>
              <p>
                Cada negocio es único: por eso mantenemos una estructura abierta
                y colaborativa. Ajustamos funcionalidades, plazos y alcances en
                tiempo real para que tu sitio o aplicación refleje siempre tus
                necesidades actuales.
              </p>
              <p>
                Nuestro enfoque ágil garantiza entregas continuas y la
                posibilidad de pivotar cuando el mercado o tus objetivos
                cambien.
              </p>
            </motion.div>

            <motion.div
              hidden={cText === 3 ? false : true}
              className="text-container"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >
              <h2 className="section-title">Orientación al cliente</h2>
              <motion.h3>Comunicación clara y soporte personalizado</motion.h3>
              <p>
                Más que proveedores, somos tus socios tecnológicos. Desde el
                arranque del proyecto hasta el final (y más allá), te
                acompañamos con atención directa, recomendaciones proactivas y
                formación práctica.
              </p>
              <p>
                Nuestro equipo está siempre disponible para resolver dudas,
                recibir tu feedback y asegurar que tu experiencia sea impecable.
              </p>
            </motion.div>

            <div className="about-icons">
              <motion.div
                initial={{ y: -50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.5 }}
                onClick={() => (cText === 1 ? setCText(0) : setCText(1))}
              >
                <BsCurrencyDollar />
                <p>Costos</p>
                <p>Accesibles</p>
              </motion.div>
              <motion.div
                initial={{ y: -50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 1.5 }}
                onClick={() => (cText === 2 ? setCText(0) : setCText(2))}
              >
                <TbArrowBearLeft2 />
                <p>Flexibilidad</p>
              </motion.div>
              <motion.div
                initial={{ y: -50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 1 }}
                onClick={() => (cText === 3 ? setCText(0) : setCText(3))}
              >
                <MdOutlineSupportAgent />
                <p>Orientación</p>
                <p>al Cliente</p>
              </motion.div>
            </div>
            <center>
              <button
                onClick={() => navigate("/portafolio")}
                style={{ margin: 5 }}
              >
                Portafolio
              </button>
              <button
                onClick={() => (window.location.href = "#reviews")}
                style={{ margin: 5 }}
              >
                Testimonios
              </button>
            </center>
          </div>
        </div>
      </motion.section>

      <motion.section
        id="facebook-page"
        className="facebook-page container"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        {/*
        <iframe
          src={`https://www.facebook.com/plugins/page.php?
            href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D61569565533751&
            tabs=timeline&
            width=500&
            height=780&
            small_header=false&
            adapt_container_width=true&
            hide_cover=false&
            show_facepile=true&
            appId=1355278275727229`}
          width="500"
          height="680"
          style={{
            border: "none",
            overflow: "hidden",
            borderRadius: 10,
            scrollbarColor: "rgb(40, 121, 125) white",
            scrollBehavior: "smooth",
            scrollbarWidth: "thin",
          }}
          scrolling="no"
          frameborder={0}
          allowfullscreen={false}
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>*/}
        <div className="reviews-container" id="reviews">
          <h2 className="section-title">Testimonios</h2>

          <div className="reviews-card-container">
            <article
              className="card-review"
              title="Testimonio de cliente satisfecho Facebook"
            >
              <FaFacebook className="card-review-social-icon" />
              <div>
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div>
                <p>
                  Excelente servicio, su equipo entiende perfectamente las
                  necesidades del cliente.
                </p>
                <strong>- Turísticos Becerros</strong>
              </div>
            </article>
            <article
              className="card-review"
              title="Testimonio de cliente satisfecho Google"
            >
              <FcGoogle className="card-review-social-icon" />
              <div>
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div>
                <p>Buen emprendimiento y trabajo que están haciendo!</p>
                <strong>- Arturo Mauricio</strong>
              </div>
            </article>
            <article
              className="card-review"
              title="Testimonio de cliente satisfecho Google"
            >
              <FcGoogle className="card-review-social-icon" />
              <div>
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div>
                <p>
                  Lo recomiendo sin ningún lugar a dudas. A ciegas se puede
                  trabajar con ellos...
                </p>
                <strong>- Jose Rivas</strong>
              </div>
            </article>
          </div>

          <a
            className="link-to-reviews"
            href={externalLinks.googleBusiness}
            target="_blank"
            rel="noreferrer"
          >
            Ver mas...
          </a>
        </div>
      </motion.section>

      <motion.section
        id="services"
        className="services container"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h2 className="section-title">Nuestros Servicios</h2>
        <motion.h3>
          Todo lo que necesita tu presencia web, en un solo lugar.
        </motion.h3>
        <motion.div
          className="services-cards"
          initial={{ opacity: 0, x: "100%" }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 2 }}
        >
          <motion.div className="service-card" whileHover={{ scale: 1.05 }}>
            <MdWeb />
            <h3>Desarrollo Web y Diseño Web</h3>
            <p>
              Desarrollo web y diseño de páginas web a medida. Creamos sitios y
              aplicaciones web profesionales a precio accesible.
            </p>
          </motion.div>
          <motion.div className="service-card" whileHover={{ scale: 1.05 }}>
            <GrHost />
            <h3>Hosting</h3>
            <p>
              Ofrecemos alojamiento web seguro y confiable con tiempos de carga
              optimizados y soporte técnico para garantizar la estabilidad de tu
              página.
            </p>
          </motion.div>
          <motion.div className="service-card" whileHover={{ scale: 1.05 }}>
            <TbWorldWww />
            <h3>Registro de dominios</h3>
            <p>
              Te ayudamos a obtener el nombre de dominio ideal para tu marca,
              asegurando una identidad digital profesional y fácil de recordar.
            </p>
          </motion.div>
        </motion.div>
        <button type="button" onClick={() => window.open(externalLinks.policy)}>
          Políticas
        </button>
      </motion.section>

      <motion.section
        id="pricing"
        className="pricing container"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h2 className="section-title">Planes</h2>
        <motion.h3>
          Paquetes claros y accesibles, pensados para adaptarse a tu proyecto y
          presupuesto
        </motion.h3>
        <div className="paquetes-container">
          {plans.map((plan, index) => (
            <motion.div
              className="paquete"
              key={index}
              initial={{ scale: 0.1 }}
              whileInView={{ scale: 1 }}
              transition={{ duration: plan.time }}
            >
              <div className="paquete-header">
                <h3>{plan.title}</h3>
                <h4>
                  {isMexico
                    ? `$${plan.priceMXN} MXN`
                    : `$${plan.priceGlobal} USD`}
                </h4>
              </div>
              <hr />
              <div className="paquete-features">
                {plan.features.map((feature, i) => (
                  <p key={i}>
                    <FaCheck className="check-icon" /> {feature}
                  </p>
                ))}
              </div>
              <button onClick={() => handleSendWaM(index)}>Elegir Plan</button>
            </motion.div>
          ))}
        </div>
      </motion.section>

      <motion.section
        id="faq"
        className="faq container"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h2 className="section-title">Preguntas Frecuentes</h2>
        <motion.h3>
          Resuelve tus dudas sobre tiempos, pagos, soporte y más antes de
          comenzar tu proyecto.
        </motion.h3>
        <p style={{ textAlign: "center" }}>
          🔍 Haz clic en cada pregunta para ver la respuesta 🔎
        </p>
        <div className="faq-items">
          <motion.details
            className="faq-item"
            initial={{ x: "-50%" }}
            whileInView={{ x: 0 }}
            transition={{ duration: 0.4 }}
          >
            <summary>¿Cuánto tiempo tardan en entregar un proyecto?</summary>
            <p>
              Dependiendo de la complejidad y alcance, un sitio web estándar
              suele estar listo en 1–2 semanas. Si incluye funcionalidades
              avanzadas (tienda en línea, integraciones externas), el plazo
              puede extenderse hasta 4–6 semanas. Definimos una ruta de
              desarrollo detallada antes de comenzar para garantizar entregas
              puntuales.
            </p>
          </motion.details>

          <motion.details
            className="faq-item"
            initial={{ x: "50%" }}
            whileInView={{ x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <summary>¿Ofrecen soporte post-proyecto?</summary>
            <p>
              Sí. Incluimos 30 días de soporte técnico gratuito tras la entrega
              (ajustes menores, resolución de errores). Tras ese periodo,
              cualquier actualización o adición tendrá un costo adicional.
            </p>
          </motion.details>

          <motion.details
            className="faq-item"
            initial={{ x: "-50%" }}
            whileInView={{ x: 0 }}
            transition={{ duration: 1.2 }}
          >
            <summary>¿Qué métodos de pago aceptan?</summary>
            <p>
              Aceptamos:
              <ul style={{ marginLeft: 15 }}>
                <li>Transferencia bancaria</li>
                <li>Depósito en cuenta</li>
                <li>PayPal</li>
                <li>Binance</li>
                <li>Entre otros</li>
              </ul>
              El 30 % se abona al inicio y el resto al finalizar el proyecto.
            </p>
          </motion.details>

          <motion.details
            className="faq-item"
            initial={{ x: "50%" }}
            whileInView={{ x: 0 }}
            transition={{ duration: 1.6 }}
          >
            <summary>¿Puedo solicitar modificaciones al diseño?</summary>
            <p>
              Claro. Trabajamos en ciclos iterativos: tras cada entrega parcial
              podrás revisar y solicitar cambios sin costo adicional para
              asegurar que el diseño refleje exactamente tu visión.
            </p>
          </motion.details>

          <motion.details
            className="faq-item"
            initial={{ x: "-50%" }}
            whileInView={{ x: 0 }}
            transition={{ duration: 1.8 }}
          >
            <summary>
              ¿Qué información o materiales debo proporcionar para iniciar el
              proyecto?
            </summary>
            <p>
              Para arrancar, necesitamos:
              <ul style={{ marginLeft: 15 }}>
                <li>Descripción de objetivos</li>
                <li>Contenido: textos, imágenes y vídeos</li>
                <li>Logotipo y paleta de colores (Opcional)</li>
                <li>Referencias de sitios que te gusten</li>
              </ul>
              Con esto definimos el alcance y creamos un plan de trabajo claro.
            </p>
          </motion.details>

          {/* Nueva pregunta: costos de hosting */}
          <motion.details
            className="faq-item"
            initial={{ x: "50%" }}
            whileInView={{ x: 0 }}
            transition={{ duration: 2 }}
          >
            <summary>¿Cuales son los costos de hosting?</summary>
            <p>
              Ofrecemos dos planes de hosting:
              <ul style={{ marginLeft: 15 }}>
                <li>Mensual: desde {isMexico ? "$20 MXN" : "$2 USD"}/mes</li>
                <li>Anual: desde {isMexico ? "$400 MXN" : "$20 USD"}/año</li>
              </ul>
              Ambos incluyen - monitoreo 24/7, soporte técnico, certificado SSL,
              backups diarios y subdominio gratis.
            </p>
          </motion.details>

          {/* Nueva pregunta: cotización de dominios */}
          <motion.details
            className="faq-item"
            initial={{ x: "-50%" }}
            whileInView={{ x: 0 }}
            transition={{ duration: 2.4 }}
          >
            <summary>¿Cuánto me cuesta registrar un dominio?</summary>
            <p>
              Los precios aproximados de registro (por año) son:
              <ul style={{ marginLeft: 15 }}>
                <li>.com: $10–15 USD</li>
                <li>.net: $12–18 USD</li>
                <li>.org: $10–15 USD</li>
                <li>.io: $30–50 USD</li>
              </ul>
              El costo varía según la extensión y el registrador. Te ayudamos a
              gestionar la compra y renovación.
            </p>
          </motion.details>
        </div>
        <br />
        <center>
          <button onClick={() => window.open(externalLinks.whatsapp)}>
            ¿Tienes otra duda?
          </button>
        </center>
      </motion.section>

      <section style={{ display: "none" }}>
        <h2>Empresa de Desarrollo Web en Guadalajara</h2>
        <p>
          Somos una de las empresas de desarrollo web en Guadalajara
          especializada en diseño de páginas web, aplicaciones web y diseño UX
          UI. Si necesitas cotizar página web o conocer el precio para hacer
          página web, contáctanos hoy.
        </p>
      </section>

      <Footer />
    </>
  );
}

export default Home;
